import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';
import { ReactComponent as Check } from '../../../svg/Check.svg';

const ItemDetails = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;

  padding: 10px;
  align-items: flex-start;
  height: auto;

  ${theme.below.lg} {
    flex-direction: column;
  }  
  
`;
const ImageWrapper = styled('div')`
  width: 100%;
  cursor: pointer;
  min-height: 275px;
  max-height: 275px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 1px solid transparent;
  border-radius: 10px;
  @media screen and (max-width: 800px) {
    min-height: unset;
    max-height: unset;
  }
  @media screen and (max-width: 600px) {
    min-height: unset;
    max-height: unset;
  }
  &.active {
    outline: 1px dashed #a8a8a8;
  }
  &:hover {
    outline: 1px dashed #a8a8a8;
  }
`;
const Image = styled('img')`
  width: 100%;
  height: auto;
  cursor: pointer;
  &.rotate {
    transform: rotateY(180deg);
  }
`;
const ItemBox = styled('div')`
  cursor: pointer;
  position: relative;
  padding: 6px 6px 0;
  &:hover {
    > div:last-of-type {
      background-color: #f5f5f5;
      p {
        font-weight: 600;
      }
    }
  }
  
  @media screen and (max-width: 600px) {
    height: max-content;
    width: calc(50% - 8px);
  }
`;
const CheckboxWrapper = styled('div')`
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 15px;
  left: 15px;
  background: #fff;
  border: 1px solid #000;
  border-radius: 100%;
  width: 25px;
  height: 25px;
  padding: 3px;
  display: none;
  &.active {
    display: flex;
    z-index: 1;
  }

  svg {
    path {
      fill: #000;
    }
  }
`;
const Checkbox = styled('input')`
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 10px;
  display: none;
  &:checked {
    background-color: #911827;
    border: 1px solid #f5f5f5;
  }
  &:hover {
    background-color: #911827;
    border: 1px solid #911827;
  }
`;

const Name = styled('p')`
  margin: 0 auto;
  &.active {
    font-weight: 600;
  }
`;

export const Item = ({ item, onClick, isActive }) => {
  return (
    <>
      <ItemBox onClick={onClick} className={isActive ? 'active' : ''}>
        <CheckboxWrapper className={isActive ? 'active' : ''}>
          <Checkbox readonly></Checkbox>
          <Check></Check>
        </CheckboxWrapper>
        <ImageWrapper className={isActive ? 'active' : ''}>
          <Image className={item?.rotateImage ? 'rotate' : ''} alt={item.images[0].alt ? item.images[0].alt : item.name} src={item.images[0].url}></Image>
        </ImageWrapper>
        <ItemDetails>
          <div style={{ width: '100%' }}>
            <Name className={isActive ? 'active' : ''}>{item?.name}</Name>
          </div>
        </ItemDetails>
      </ItemBox>
    </>
  );
};
